import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import {
  getHasConfirmedEmail,
} from '@SiteModules/User/selectors'

const Forwarder: React.FC = () => {
  const confirmedEmail = useSelector(getHasConfirmedEmail)

  const shouldForwardToEmailConfirmationPage = !confirmedEmail

  return (
    <React.Fragment>
      {shouldForwardToEmailConfirmationPage && (
        <Navigate to="/onboarding/check_email" />
      )}
    </React.Fragment>
  )
}

export default Forwarder
